import { TAssetsDataTableData } from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/prepaidApplication/assetsAndIncome/assets/AssetsDataTableMeta';
import {
  CustomTextInput,
  CustomInputCheckBox,
  CustomInputSelect
} from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';

import { IAssetsFormMeta } from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/prepaidApplication/assetsAndIncome/assets/AssetsMeta';
type Props = {
    meta: IAssetsFormMeta,
    data: TAssetsDataTableData
} & TFormUIProps;

export default React.forwardRef(function AssetsFormUI ({ onSubmit, isLoading, isSubmitting, meta, data }: Props, ref: any) {

  const submitBtnRef = React.useRef<HTMLButtonElement>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ 
    defaultValues: data,
    resolver: yupResolver(meta.schema) 
  });

  React.useImperativeHandle(ref, () => ({
    submitBtnRef
  }));

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)} ref={ref} py={5}>

<CC.SimpleGrid columns={{base: 1, md: 2}} spacing={10} mb={10}>
        <CustomFormControl
          label={meta.assetDescription.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.assetDescription.name]}
        >
          <CustomInputSelect
            meta={meta.assetDescription}
            register={register(meta.assetDescription.name)}
            hasError={errors[meta.assetDescription.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.accountNumber.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.accountNumber.name]}
        >
          <CustomTextInput
            meta={meta.accountNumber}
            register={register(meta.accountNumber.name)}
            hasError={errors[meta.accountNumber.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.accountName.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.accountName.name]}
        >
          <CustomTextInput
            meta={meta.accountName}
            register={register(meta.accountName.name)}
            hasError={errors[meta.accountName.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.debt.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.debt.name]}
        >
          <CustomInputCheckBox
            meta={meta.debt}
            register={register(meta.debt.name)}
            hasError={errors[meta.debt.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.value.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.value.name]}
        >
          <CustomTextInput
            meta={meta.value}
            register={register(meta.value.name)}
            hasError={errors[meta.value.name]}
          />
        </CustomFormControl>
      </CC.SimpleGrid>
      
      <button type={'submit'} ref={submitBtnRef} style={{display: "none"}}>
        Enregistrer
      </button>
    </CC.Box>
  );
});

// export default AssetsFormUI;
